
// @params
// user: objeto con los datos del usuario

const validate = (estimate) => {

    let isOk = false
    let resultMessage = ""

    if (!estimate) {
        resultMessage = "Presupuesto vacío"
        return ({ isOk, resultMessage })
    }

    if (!estimate.name) {
        resultMessage = "Por favor, introduzca el nombre"
        return ({ isOk, resultMessage })
    }

    if (!estimate.email) {
        resultMessage = "Por favor, introduzca el email"
        return ({ isOk, resultMessage })
    }

    if (!is_real_email(estimate.email)) {
        resultMessage = "Formato de email incorrecto"
        return ({ isOk, resultMessage })
    }

    if (!estimate.phone) {
        resultMessage = "Por favor, introduzca el teléfono"
        return ({ isOk, resultMessage })
    }

    if (!is_real_phone(estimate.phone)) {
        resultMessage = "Formato de teléfono incorrecto"
        return ({ isOk, resultMessage })
    }

    if (!estimate.institution) {
        resultMessage = "Por favor, introduzca la institución"
        return ({ isOk, resultMessage })
    }

    if (!estimate.subject) {
        resultMessage = "Por favor, introduzca el asunto"
        return ({ isOk, resultMessage })
    }

    if (!estimate.message) {
        resultMessage = "Por favor, introduzca el mensaje"
        return ({ isOk, resultMessage })
    }

    if (!estimate.accepted) {
        resultMessage = "Por favor, acepte la política de privacidad"
        return ({ isOk, resultMessage })
    }

    isOk = true

    return ({ isOk, resultMessage })
}


// Validador de teléfono

function is_real_phone(telefono) {

    if (!telefono) return false
    const validador = new RegExp("^(\\+34|0034|34)?[6789]\\d{8}$");
    return validador.test(telefono)

}


// Validador de Email 

function is_real_email(email) {

    if (!email) return false
    const validador = new RegExp('^[^@]+@[^@]+.[a-zA-Z]{2,}$');
    return validador.test(email)

}

module.exports = {
    validate
}